/**
 * フルスクリーン時に、キー操作でコントロールバーが表示されやすくなる現象への暫定対応
 * フルスクリーンに入ると、プレイヤー全体にフォーカスが当たっている状態になるため、どのキーを操作しても active 判定になってしまう模様
 * フルスクリーンに入る時/プレイヤー全面クリック時にフォーカスを外すことで、その後のキー操作で active 判定にならないようにする
 * アクセシビリティ的に正しくなさそうなので、これでいいかは要検討
 */
export const blurFromActiveElement = () => {
  try {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  } catch (e) {
    console.error(e);
  }
};
